import { ENDPOINTS } from "@horseed/shared/endpoints";
import { API_BASE_URL, apiRequest, authHeader } from "./http";

const { MESSAGES, SUBSCRIPTIONS, ZONES } = ENDPOINTS;

// POST /api/v1/Messages - body: { content, email }
export async function sendContactMessage({ content, email }, token) {
  if (!content || !content.trim())
    throw new Error("Message content is required");
  const json = await apiRequest(`${API_BASE_URL}${MESSAGES.CREATE}`, {
    method: "POST",
    headers: authHeader(token),
    body: JSON.stringify({ content, email: email || "" }),
  });
  return json?.data ?? null;
}

// POST /api/v1/Subscriptions - body: { email }
export async function subscribeEmail(email, token) {
  if (!email) throw new Error("Email is required");
  const json = await apiRequest(`${API_BASE_URL}${SUBSCRIPTIONS.CREATE}`, {
    method: "POST",
    headers: authHeader(token),
    body: JSON.stringify({ email }),
  });
  return json?.data ?? null;
}

// DELETE /api/v1/Subscriptions - body: { token, email }
export async function unsubscribeEmail({ token: unsubToken, email }) {
  const json = await apiRequest(`${API_BASE_URL}${SUBSCRIPTIONS.DELETE}`, {
    method: "DELETE",
    body: JSON.stringify({ token: unsubToken || "", email: email || "" }),
  });
  return json?.data ?? null;
}

// GET /api/v1/Zones/by-location?latitude={lat}&longitude={lng}
export async function resolveZoneByLocation(latitude, longitude) {
  const params = new URLSearchParams({
    latitude: String(latitude),
    longitude: String(longitude),
  });
  const json = await apiRequest(`${API_BASE_URL}${ZONES.BY_LOCATION}?${params}`);
  return json?.data ?? null;
}
